import { RouteConfig } from 'vue-router'
import { mobileAppCustomiserRoutes } from '../constants/agency/'
import { requireAuth } from '../auth'

const MobileAppCustomiserMicroApp = () =>
  import(
    '@/pmd/pages/mobileAppCustomiser/MobileAppCustomiserMicroApp.vue'
  ).then(m => m.default)

export const mobileAppCustomiser: RouteConfig[] = [
  {
    path: '/mobile-app-customiser',
    name: mobileAppCustomiserRoutes.default,
    component: MobileAppCustomiserMicroApp,
    beforeEnter: requireAuth,
    children: [],
  },
]
